export default __webpack_public_path__ + "static/media/anger.d9dc74bd.svg";